export enum AuthoryColorSchemes {
    light = "light",
    userTheme = "userTheme"
}
